import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AdminSupportCountsView, StatFilterKind, SupportStatus } from 'src/app/common/models/support/admin-support.models';

@Component({
  selector: 'app-stat-cards',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './stat-cards.component.html',
  styleUrls: ['./stat-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatCardsComponent {
  counts = input<AdminSupportCountsView | null>(null);
  tab = input.required<SupportStatus>();
  statFilter = input<StatFilterKind | null>(null);

  @Output() cardClicked = new EventEmitter<'open' | StatFilterKind>();

  isOpenActive(): boolean {
    return this.tab() === 'Open' && this.statFilter() === null;
  }

  onCardClick(kind: 'open' | StatFilterKind) {
    this.cardClicked.emit(kind);
  }
}
